import { useEffect, useState } from 'react';
import { setSession } from './utils';
import axios from 'axios';
import { endpoints } from '@/lib/axios/axios-global';
import { useAppDispatch } from '@/core/global-store';
import { setCredentials } from '@/core/global-store/features/auth/authSlice';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '@repo/ui/components/Loading/LoadingSpinner';

const STORAGE_KEY = 'accessToken';

type Props = {
    children: React.ReactNode;
};

export function AuthInitializer({ children }: Props) {
    const dispatch = useAppDispatch();
    const [isUserLoggedin, setIsUserLoggedin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const accessToken = Cookies.get(STORAGE_KEY);

                if (accessToken) {
                    setSession(accessToken);

                    const res = await axios.get(endpoints.auth.me);
                    const me = res.data;

                    dispatch(setCredentials({ token: accessToken, me }));
                    setIsUserLoggedin(true);
                } else {
                    dispatch(setCredentials({ token: null, me: null }));
                    navigate('/login');
                }
            } catch {
                dispatch(setCredentials({ token: null, me: null }));
                navigate('/login');
            }
        })();
    }, [dispatch, navigate]);

    if (!isUserLoggedin) {
        return <LoadingSpinner />;
    }

    return <>{children}</>;
}
